import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';
import { gutter } from '../../styles/mixins';

const Host = styled.header<{ isAuthenticated: boolean }>`
  display: flex;
  justify-content: ${(props) =>
    !props.isAuthenticated ? 'center' : 'space-between'};
  align-items: center;
  padding: 18px ${gutter(2)};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  @media ${device.mobile} {
    padding-left: ${({ theme }) => theme.breakpoints.sm.gutter}px;
    padding-right: ${({ theme }) => theme.breakpoints.sm.gutter}px;
  }

  @media ${device.tablet} {
    padding-left: ${({ theme }) => theme.breakpoints.md.gutter}px;
    padding-right: ${({ theme }) => theme.breakpoints.md.gutter}px;
  }
`;

const Logo = styled.div`
  a {
    display: flex;
  }
`;

const UserIcon = styled.div``;

interface HeaderProps {
  logo: React.ReactNode;
  userIcon: React.ReactNode;
  isAuthenticated: boolean;
}

export const Header = ({ logo, userIcon, isAuthenticated }: HeaderProps) => {
  return (
    <Host isAuthenticated={isAuthenticated}>
      <Logo>{logo}</Logo>
      {isAuthenticated && <UserIcon>{userIcon}</UserIcon>}
    </Host>
  );
};
